export default __webpack_public_path__ + "static/media/lorandointerview.81a2792c.png";